import { select, call, put } from 'redux-saga/effects';
import equal from 'fast-deep-equal';
import { getPONextStepsNormalized, getProductsNextStepsNormalized, getTermsNextStepsNormalized } from './normalizers/nextSteps';
import { actions as nextStepsActions } from '../reducers/nextSteps';
import { actions as uiNeedsActions } from '../reducers/uiNeeds';
import { actions as loaderControlActions } from '../reducers/loaderControl';
import { getByName } from './customizer';

// A selector function that retrieves the apiNeeds state from the store
const apisNeedsStore = state => state.apiNeeds;
const nextStepsStore = state => state.nextSteps;
const offerStore = state => state.offer;


// This is a generator function (denoted by the `*` before the function name)
// that retrieves and normalizes data for the next steps of a process
export function* getNextSteps(input) {
  // Dispatches an action to set the `loading` state to `true`
  yield put(loaderControlActions.setLoaderState({
    loading: true,
  }));

  // Retrieves the apiNeeds state from the store using the `select` effect
  const { poshtSelected, poitSelected, poptSelected, allChoices } = yield select(apisNeedsStore);
  const { allPOsToBuy, cisi } = yield select(offerStore);

  const { nextStepsDataInfo } = yield select(nextStepsStore);

  try {
    // The name of the activity for which we are retrieving next steps
    const ACTIVITY_NAME = 'TELCO-NextSteps';
    // Parameters for the `getByName` function call
    const getByNameParams = {
      ...input,
      name: ACTIVITY_NAME,
      custoType: 'activity',
    };

    // Makes an API request to retrieve data using the `getByName` function
    const response = yield call(getByName, getByNameParams);

    // Data for the selected terms
    const termsSelected = {
      poshtSelected,
      poitSelected,
      poptSelected,
    };

    // Normalizes the response data for the products
    const productsNextStepsNormalized = getProductsNextStepsNormalized(response, allChoices);
    // Normalizes the response data for the terms
    const termsNextStepsNormalized = getTermsNextStepsNormalized(response, termsSelected);
    // Normalizes the response data by productOffering
    const { poFinalNextSteps, finalConfirmationTexts } = getPONextStepsNormalized(response, [...allPOsToBuy, cisi]);

    // Combines the normalized data for products and terms into a single array
    const nextStepsNormalized = [...productsNextStepsNormalized, ...termsNextStepsNormalized, ...poFinalNextSteps];

    const finalNextStepsNormalized = [];

    nextStepsNormalized.forEach((nextStep) => {
      if (!nextStepsDataInfo.find(actualNextStep => equal(actualNextStep, nextStep))) {
        finalNextStepsNormalized.push(nextStep);
      }
    });

    // Saves the combined normalized data to the application's state
    yield put(nextStepsActions.saveNextStepsData(finalNextStepsNormalized));
    yield put(uiNeedsActions.setConfirmationTexts(finalConfirmationTexts));

    // Returns nextSteps normalized
    return nextStepsNormalized;
  } catch (e) {
    console.log(e);
    return null;
  }
}
